import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { ExclamationCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { THEME_COLORS, COLORS, GRADIENTS } from '../utils/colors';

const { Title, Text } = Typography;

const InactiveSubscription = () => {
  const handleReactivateSubscription = () => {
    // Redirect to pricing page in the same tab to complete the subscription flow
    window.location.href = '/pricing';
  };

  return (
    <div style={{ 
      minHeight: '100vh',
      background: THEME_COLORS.DARK.bg.primary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px'
    }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        <Card style={{ 
          background: THEME_COLORS.DARK.bg.secondary,
          border: `1px solid ${THEME_COLORS.DARK.border.secondary}`,
          borderRadius: '16px',
          textAlign: 'center',
          color: THEME_COLORS.DARK.text.primary
        }}>
          {/* Error Icon */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: `${COLORS.ERROR[500]}15`,
              border: `2px solid ${COLORS.ERROR[500]}30`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto'
            }}>
              <ExclamationCircleOutlined style={{ 
                color: COLORS.ERROR[500], 
                fontSize: '40px' 
              }} />
            </div>
          </div>

          {/* Title */}
          <Title level={2} style={{ 
            color: THEME_COLORS.DARK.text.primary,
            marginBottom: '16px'
          }}>
            Subscription Inactive
          </Title>

          {/* Description */}
          <Text style={{ 
            color: THEME_COLORS.DARK.text.secondary,
            fontSize: '16px',
            lineHeight: '1.6',
            marginBottom: '32px',
            display: 'block'
          }}>
            Your subscription is currently inactive. To continue using our services, please reactivate your subscription by updating your payment method.
          </Text>

          {/* Action Buttons */}
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Button 
              type="primary"
              size="large"
              icon={<ReloadOutlined />}
              onClick={handleReactivateSubscription}
              disabled
              style={{
                background: THEME_COLORS.DARK.bg.tertiary,
                border: `1px solid ${THEME_COLORS.DARK.border.primary}`,
                color: THEME_COLORS.DARK.text.muted,
                borderRadius: '8px',
                height: '48px',
                fontSize: '16px',
                fontWeight: 600,
                width: '100%',
                cursor: 'not-allowed',
                opacity: 0.6
              }}
            >
              Reactivate Subscription
            </Button>

          </Space>

          {/* Additional Info */}
          <div style={{ 
            marginTop: '32px',
            padding: '16px',
            background: THEME_COLORS.DARK.bg.tertiary,
            borderRadius: '8px',
            border: `1px solid ${THEME_COLORS.DARK.border.primary}`
          }}>
            <Text style={{ 
              color: THEME_COLORS.DARK.text.muted,
              fontSize: '13px',
              lineHeight: '1.5'
            }}>
              Need help? Contact our support team at{' '}
              <Text 
                style={{ 
                  color: COLORS.PRIMARY[500],
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
                onClick={() => window.open('mailto:support@hooptie.com', '_blank')}
              >
                support@hooptie.com
              </Text>
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default InactiveSubscription;
